import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { Middleware, PayloadAction, MiddlewareAPI } from "@reduxjs/toolkit";

import { updatelastIsRejectedApiError } from "app/configSlice";

interface IServerErrorPayload {
  status: number;
  data: {
    error: string;
    error_description: string;
  };
}

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action: PayloadAction<IServerErrorPayload>) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (isRejectedWithValue(action) && action?.type === "neftApiSlice/executeMutation/rejected") {
      api.dispatch(updatelastIsRejectedApiError(action));
    }

    return next(action);
  };
